module.exports = __webpack_public_path__ + "static/media/shareBg2.d1a4c4ee.png";